export class RateActivityInput {

    activityId: Number;
    userId: Number;
    rate: number;
}
